var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 0.333252C3.81967 0.333252 0.833008 3.31992 0.833008 6.99992C0.833008 10.6799 3.81967 13.6666 7.49967 13.6666C11.1797 13.6666 14.1663 10.6799 14.1663 6.99992C14.1663 3.31992 11.1797 0.333252 7.49967 0.333252ZM5.69301 9.85992L3.29967 7.46658C3.03967 7.20658 3.03967 6.78658 3.29967 6.52659C3.55967 6.26658 3.97967 6.26658 4.23967 6.52659L6.16634 8.44658L10.753 3.85992C11.013 3.59992 11.433 3.59992 11.693 3.85992C11.953 4.11992 11.953 4.53992 11.693 4.79992L6.63301 9.85992C6.37967 10.1199 5.95301 10.1199 5.69301 9.85992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/CorrectIcon.98bd0119efac422a45154fff59a11cd8.svg";
export { ForwardRef as ReactComponent };